import { Helmet } from "react-helmet";

export default function GoogleAnalytics() {
    return (
        <Helmet>
            <script
                async
                src="https://www.googletagmanager.com/gtag/js?id=G-7G4L5K6DX5"
            />
            <script>
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-7G4L5K6DX5', {
            send_page_view: true
          });
        `}
            </script>
        </Helmet>
    );
}
